interface VehicleDisplayFields {
  make: string | null;
  model: string | null;
  year: number | null;
  operator?: {
    carrierUser?: {
      name: string | null;
    } | null;
  } | null;
}

export function vehicleDisplayName(vehicle: VehicleDisplayFields): string {
  return [vehicle.make, vehicle.model, vehicle.year]
    .filter(
      (value) =>
        value !== null && value !== undefined && String(value).trim().length > 0
    )
    .join(" ");
}

export function vehicleOperatorDisplayName(
  vehicle: VehicleDisplayFields
): string {
  return vehicle.operator ? operatorDisplayName(vehicle.operator) : "";
}

export function vehicleCapacityDisplay(capacity: unknown): string {
  if (capacity === null || capacity === undefined) {
    return "Capacity unavailable";
  }
  if (
    typeof capacity === "string" ||
    typeof capacity === "number" ||
    typeof capacity === "boolean"
  ) {
    return `${String(capacity)} (unit not provided)`;
  }
  if (typeof capacity === "object" && !Array.isArray(capacity)) {
    const entries = Object.entries(capacity as Record<string, unknown>).filter(
      ([, value]) => value !== null && value !== undefined
    );
    if (
      entries.every(([, value]) =>
        ["string", "number", "boolean"].includes(typeof value)
      )
    ) {
      return entries.length > 0
        ? entries
            .map(([unit, value]) => {
              const suffix = capacityKeyDeclaresUnit(unit)
                ? ""
                : " (unit not provided)";
              return `${unit}: ${String(value)}${suffix}`;
            })
            .join(", ")
        : "Capacity unavailable";
    }
  }
  try {
    return JSON.stringify(capacity, null, 2) ?? "Capacity unavailable";
  } catch {
    return "Capacity data is unavailable.";
  }
}

function capacityKeyDeclaresUnit(key: string): boolean {
  const normalized = key.toLocaleLowerCase().replace(/[^a-z0-9]/g, "");
  return /(?:kg|kgs|kilograms?|grams?|lbs?|pounds?|ounces?|liters?|litres?|ml|m3|cm3|ft3|cubicmeters?|cubicmetres?|parcels?|packages?|items?|pieces?|units?|pallets?|parcelcount|packagecount|itemcount|piececount|palletcount)$/.test(
    normalized
  );
}
import { operatorDisplayName } from "./operator-identity";
